import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import ThermostatOutlinedIcon from '@mui/icons-material/ThermostatOutlined'
import UmbrellaOutlinedIcon from '@mui/icons-material/UmbrellaOutlined'
import AirOutlinedIcon from '@mui/icons-material/AirOutlined'
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum WeatherRecordSectionIds {
  general = 'general',
  temperature = 'temperature',
  precipitation = 'precipitation',
  wind = 'wind',
  sky = 'sky',
}

/**
 * @description Sections shared by the Weather Record detail page and edit form, in display order.
 */
export const weatherRecordSections: SectionDefinition[] = [
  {
    id: WeatherRecordSectionIds.general,
    title: 'General',
    description: 'Weather group, record type, and when the reading was taken.',
    icon: InfoOutlinedIcon,
  },
  {
    id: WeatherRecordSectionIds.temperature,
    title: 'Temperature',
    description: 'Temperature readings in °C.',
    icon: ThermostatOutlinedIcon,
  },
  {
    id: WeatherRecordSectionIds.precipitation,
    title: 'Precipitation',
    description: 'Rain and snow in the hour before the timestamp, in mm. Used by the status algorithm.',
    icon: UmbrellaOutlinedIcon,
  },
  {
    id: WeatherRecordSectionIds.wind,
    title: 'Wind & Air',
    description: 'Wind speed (m/s) and direction (°), air pressure (hPa), and relative humidity (%).',
    icon: AirOutlinedIcon,
  },
  {
    id: WeatherRecordSectionIds.sky,
    title: 'Sky & Sun',
    description: 'Weather condition, UV rating, and sunrise and sunset times.',
    icon: WbSunnyOutlinedIcon,
  },
]
